/*
 * @Author: zhao - 🍉
 * @Date: 2021-12-30 16:26:26
 * @LastEditTime: 2022-01-28 21:19:53
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账报表
 * @FilePath: /zhzj-admin/src/services/platformReport.js
 */
import { API_NAME } from "../axios/config";
import request from "../utils/request";


/**
 * 平台对账报表 - 获取列表数据
 * @param {*} params 
 * @returns 
 */
export function fetchPlatformReportList(data) {
    return request({
        url: '/platform/verifyReportForm/reportForm',
        method: 'post',
        data
    })
}


/**
 * 项目监控 - 获取列表数据
 * @param {*} params
 * @returns
 */
export function fetchProjectMonitoringFormList(data) {
    return request({
        url: '/platform/verifyReportForm/projectMonitoringForm',
        method: 'post',
        data
    })
}


/**
 * 平台对账报表 - 导出列表数据
 */
export const apiPlatformReportExport = API_NAME + '/platform/verifyReportForm/exportReportForm'

/**
 * 項目監控數據 - 导出列表数据
 */
export const apiPlatformProjectMonitoringForm = API_NAME + '/platform/verifyReportForm/exportProjectMonitoringForm'

/**
 * 平台对账报表 - 获取单个商户统计数据
 * @param {*} params 
 * @returns 
 */
export function fetchPlatformReportMerchantStatistics(data) {
    return request({
        url: '/platform/verifyReportForm/getReportFormTradeRecordTotalMoney',
        method: 'post',
        data
    })
}

/**
 * 平台对账报表 - 获取单个商户列表数据
 * @param {*} params 
 * @returns 
 */
 export function fetchPlatformReportMerchantList(data) {
    return request({
        url: '/platform/verifyReportForm/findReportFormTradeRecordPage',
        method: 'post',
        data
    })
}

/**
 * 平台对账报表 - 汇总报表数据
 * @param {*} params 
 * @returns 
 */
 export function fetchPlatformReportSummary(data) {
    return request({
        url: '/platform/verifyReportForm/reportFormSummary',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/services/platformReport.js